var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13.2134C6 13.4895 6.22386 13.7134 6.5 13.7134L14.5 13.7134C14.7761 13.7134 15 13.4895 15 13.2134L15 4.21338C15 3.93724 14.7761 3.71338 14.5 3.71338L6.5 3.71338C6.22386 3.71338 6 3.93724 6 4.21338L6 6.21338C6 6.48952 5.77614 6.71338 5.5 6.71338C5.22386 6.71338 5 6.48952 5 6.21338L5 4.21338C5 3.38495 5.67157 2.71338 6.5 2.71338L14.5 2.71338C15.3284 2.71338 16 3.38495 16 4.21338L16 13.2134C16 14.0418 15.3284 14.7134 14.5 14.7134L6.5 14.7134C5.67157 14.7134 5 14.0418 5 13.2134L5 11.2134C5 10.9372 5.22386 10.7134 5.5 10.7134C5.77614 10.7134 6 10.9372 6 11.2134L6 13.2134Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.146446 9.06693C-0.0488157 8.87167 -0.0488157 8.55509 0.146446 8.35983L3.14645 5.35983C3.34171 5.16456 3.65829 5.16456 3.85355 5.35983C4.04882 5.55509 4.04882 5.87167 3.85355 6.06693L1.70711 8.21338L10.5 8.21338C10.7761 8.21338 11 8.43724 11 8.71338C11 8.98952 10.7761 9.21338 10.5 9.21338L1.70711 9.21338L3.85355 11.3598C4.04882 11.5551 4.04882 11.8717 3.85355 12.0669C3.65829 12.2622 3.34171 12.2622 3.14645 12.0669L0.146446 9.06693Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.55901b9eb28fdd0daa2c4bb550b0a311.svg";
export { ForwardRef as ReactComponent };